

export const appRequestFormValidator = (formFields) => {
    const { ApplicationTypeID, FileName, FileType, ProofFile, ReasonID } = formFields;
    const newErrors = {};
    // Validate Password
    if (!ApplicationTypeID || ApplicationTypeID === "") {
        newErrors.ApplicationTypeID = "Application Type  is Required!";
    }

    if (!FileName || FileName.trim() === "") {
        newErrors.FileName = "File Name is Required!";
    }

    if (!FileType || FileType === "") {
        newErrors.FileType = "File Type is Required!";
    }
    if (!ProofFile || ProofFile === "") {
        newErrors.ProofFile = "Proof File is Required!";
    }

    if (!ReasonID || ReasonID === "") {
        newErrors.ReasonID = "Reason  is Required!";
    }

    return newErrors;
};
export const travelInfo = (formFields) => {
    const { TravellingPurposeID, CountryID, OccupationID } = formFields;
    const newErrors = {};
    if (!TravellingPurposeID || TravellingPurposeID === "") {
        newErrors.TravellingPurposeID = "Dhumuni la Safari Linahitajika!";
    }
    if (!CountryID || CountryID === "") {
        newErrors.CountryID = "Nchi Unayokwenda Inahitajika!";
    }


    if (!OccupationID || OccupationID === "") {
        newErrors.OccupationID = "Kazi unayofanya Inahitajika!";
    }

    return newErrors;
};

export const addressInfo = (formFields) => {

    const { ResidenceDistrictID, ResidenceVillage } = formFields;
    const newErrors = {};
    if (!ResidenceDistrictID || ResidenceDistrictID === "") {
        newErrors.ResidenceDistrictID = "Wilaya ya makazi inahitajika!";
    }
    if (!ResidenceVillage || ResidenceVillage === "") {
        newErrors.ResidenceVillage = "Kijiji cha Makazi kinahitajika!";
    }



    return newErrors;
};

export const personalInfo = (formFields) => {

    const { BirthVillage, BirthWardID, DateofBirth, FamilyName, FirstName, GenderID } = formFields;
    const newErrors = {};
    if (!FirstName || FirstName.trim() === "")
        newErrors.FirstName = "Jina la Kwanza Linahitajika!";
    if (!FamilyName || FamilyName.trim() === "")
        newErrors.FamilyName = "Jina la Ukoo Linahitajika!";
    if (!GenderID || GenderID === "")
        newErrors.GenderID = "Jinsia Inahitajika!";
    if (!DateofBirth || DateofBirth === "")
        newErrors.DateofBirth = "Tarehe ya Kuzaliwa Inahitajika!";

    if (!BirthWardID || BirthWardID === "")
        newErrors.BirthWardID = "Kata ya Kuzaliwa Inahitajika!";

    if (!BirthVillage || BirthVillage === "")
        newErrors.BirthVillage = "Kijiji cha Kuzaliwa Kinahitajika!";
    return newErrors;
};

export const personalInfoB = (formFields) => {
    const { BirthVillage, BirthWardID } = formFields;
    const newErrors = {};
    if (!BirthWardID || BirthWardID === "")
        newErrors.BirthWardID = "Kata ya Kuzaliwa Inahitajika!";

    if (!BirthVillage || BirthVillage === "")
        newErrors.BirthVillage = "Kijiji cha Kuzaliwa Kinahitajika!";
    return newErrors;
};

export const loginFormValidator = (formFields) => {
    const { Password, CheckNumber } = formFields;
    const newErrors = {};

    // Validate Password
    if (!Password || Password.trim() === "") {
        newErrors.Password = "Password is Required!";
    } else if (Password.length < 8) {
        newErrors.Password = "Password not less 8 digits!";
    }

    // Validate CheckNumber
    if (!CheckNumber || CheckNumber.trim() === "") {
        newErrors.CheckNumber = "Check Number is Required!";
    } else if (!/^\d+$/.test(CheckNumber)) {
        newErrors.CheckNumber = "Check Number must contain only digits!";
    } else if (CheckNumber.length < 8) {
        newErrors.CheckNumber = "Check Number must be at least 8 digits!";
    } else if (CheckNumber.length > 12) {
        newErrors.CheckNumber = "Check Number must not be more than 12 digits!";
    }

    return newErrors;
};


export const resetFormValidator = (formFields) => {
    const { NationalID, CheckNumber } = formFields;
    const newErrors = {};

    // Validate NationalID
    if (!NationalID || NationalID.trim() === "") {
        newErrors.NationalID = "National ID is Required!";
    } else if (NationalID.length != 20) {
        newErrors.NationalID = "National ID must be  20 characters!";
    } else if (!/^[a-zA-Z0-9]+$/.test(NationalID)) {
        newErrors.NationalID = "National ID must contain only letters and numbers!";
    }

    // Validate CheckNumber
    if (!CheckNumber || CheckNumber.trim() === "") {
        newErrors.CheckNumber = "Check Number is Required!";
    } else if (!/^\d+$/.test(CheckNumber)) {
        newErrors.CheckNumber = "Check Number must contain only digits!";
    } else if (CheckNumber.length < 8) {
        newErrors.CheckNumber = "Check Number must be at least 8 digits!";
    } else if (CheckNumber.length > 12) {
        newErrors.CheckNumber = "Check Number must not be more than 12 digits!";
    }


    return newErrors;
};


export const verifyFormValidator = (formFields) => {
    const { VerificationCode } = formFields;
    const newErrors = {};
    if (!VerificationCode || VerificationCode === "")
        newErrors.VerificationCode = "Verification Code is Required!";
    return newErrors;
};

export const passwordFormValidator = (formFields) => {
    const { Password, confirmPassword } = formFields;
    const newErrors = {};
    if (!confirmPassword || confirmPassword.trim() === "")
        newErrors.confirmPassword = "Confirm Password  is Required!";
    if (!Password || Password.trim() === "")
        newErrors.Password = "Password  is Required!";
    if (Password.trim() !== confirmPassword.trim())
        newErrors.Password = "Passwords do not match!";
    return newErrors;
};